export default "__VITE_ASSET__Cnj3LCvw__"